import { Syntax } from '@trlogic/ui-pack';
import View from '../view/View';
import AbstractNodeView from './AbstractNodeView';
import NodeViewConstructorArgs from '../constructor/NodeViewConstructorArgs';
import * as d3 from 'd3';
import WorkFlowView from '../view/WorkFlowView';
import { NodeType, RuleJsonModel } from '../../../../domain/collection/rule/FlowDomains';
import NotFraudNodeView from './NotFraudNodeView';
import eventDisable from '../assets/event_disable.svg';

class PriorityNodeView extends AbstractNodeView {
  public constructor(args: NodeViewConstructorArgs) {
    super(args);
  }

  public initialize(): void {
    this.render();
  }

  public render(): void {
    let node: any;

    if (this.shadow) {
      node = d3.select((this.workFlowView as WorkFlowView).getParent()).append('svg');
    } else {
      node = d3
        .select((this.workFlowView as WorkFlowView).getNode())
        .select('#workflow-container-group')
        .append('g');
    }

    const nodeEnter = node
      .attr('id', this.el.substring(1, this.el.length))
      .attr('data-testid', 'priority_input')
      .attr('type', 'Priority')
      .style('position', 'absolute')
      .style('pointer-events', 'auto')
      .style('width', '50px')
      .style('height', '50px');

    nodeEnter
      .append('rect')
      .attr('width', 50)
      .attr('height', 50)
      .attr('rx', 3)
      .style('stroke', this.getColor())
      .attr('stroke-width', 1)
      .style('fill', 'white')
      .style('stroke-dasharray', '0');

    nodeEnter
      .append('text')
      .attr('x', 50 / 2 + 40)
      .attr('y', 50 / 2 - 2)
      .attr('dy', '.35em')
      .style('fill', '#4F4F4F')
      .text(this.getText());

    nodeEnter
      .append('foreignObject')
      .attr('width', 40)
      .attr('height', 40)
      .attr('x', 5)
      .attr('y', 5)
      .append('xhtml:input')
      .attr('id', 'priority_input')
      .style('width', '100%')
      .style('text-align', 'center')
      .style('font-size', '16px')
      .style('border-radius', '25px')
      .style('border', `2px solid ${this.getColor(true)}`)
      .style('height', '100%')
      .style('fill', '#FEE4FF')
      .style('color', '#D845F0')
      .style('background-color', this.getBackgroundColor())
      .attr('type', 'number')
      .attr('min', 0)
      .attr('max', 100)
      .attr('value', this.workFlowView.getModel<RuleJsonModel>().priority)
      .on('input', (event: any) => {
        let inputValue = event.target.value;
        if (inputValue > 999) {
          event.target.value = 999;
          inputValue = 999;
        }
        if (inputValue < 0) {
          event.target.value = 1;
          inputValue = 1;
        }
        if (inputValue == 0) {
          inputValue = 1;
        }
        this.workFlowView.setPriority(parseInt(inputValue));
        this.setTextAndRender();
      })
      .on('focus', function () {
        node.select('foreignObject').select('input').style('outline', 'none');
      });

    const status = this.getModel<any>().value.status;
    if (status === false) {
      d3.selectAll(this.getNode()).select('rect').style('stroke', '#bdbdbd').style('stroke-dasharray', '6');
      d3.selectAll(this.getNode())
        .select('image')
        .attr('xlink:href', eventDisable)
        .attr('width', 20)
        .attr('height', 20)
        .style('fill', 'red')
        .attr('x', 50 / 2 - 10)
        .attr('y', 50 / 2 - 10);

      d3.select(this.getNode()).select('#priority_input').style('fill', '#4F4F4F').style('color', '#bdbdbd').style('background-color', 'white');
    } else {
      d3.selectAll(this.getNode()).select('rect').style('stroke', '#D845F0');
      d3.selectAll(this.getNode()).select('text').style('fill', '#4F4F4F');
    }
  }

  private setTextAndRender() {
    const node = d3.select(this.el);
    node.select('text').text(this.getText());
  }

  public socketHighlight(type?: NodeType) {}

  public socketUnHighlight(): void {}

  protected preSwap(target: View<Syntax>): boolean {
    switch (target.constructor) {
      case NotFraudNodeView:
        return true;
      default:
        return false;
    }
  }

  public setModel(model: Syntax) {
    d3.select(this.el)
      .select('text')
      .text((model.value as any).name);
  }

  private getText = () => {
    return 'Priority';
  };

  private getColor = (border?: boolean) => {
    return '#FAFAFA';
  };

  private getBackgroundColor = () => {
    return '#FEE4FF';
  };
}

export default PriorityNodeView;
